<!--
 * @Author: Cathy
 * @Date: 2020-02-27 13:46:17
 * @LastEditors: yezi
 * @LastEditTime: 2020-07-16 16:48:02
 * @Description: 安麟产品说明
 -->
<template>
 <div class="productDirection">
  <topMenu :isShowMenu="false" pageType='motor' />
  <catalogue :list="list" />
  <!-- <lianbaDownLoad :downloadLink="downloadLink" /> -->
  <div class="seriesList">
    <div class="seriesItem" v-for="(item, index) in series_data" :key="index" @click="onSelectSeries(item,index)">
      <div class="tit" :class="type === index?'act':''" :style="{'background':(type === index?item.bgcolor:'')}">{{item.names}}</div>
    </div>
  </div>

  <div class="navbar">
    <div class="navBarItem" @click="onChange(4)">
      <p :class="params.type === 4 ? 'textSelected' : ''">视频说明</p>
      <div v-if="params.type === 4" class="dot"></div>
    </div>
    <div class="navBarItem" @click="onChange(5)">
      <p :class="params.type === 5 ? 'textSelected' : ''">图文说明</p>
      <div v-if="params.type === 5" class="dot"></div>
    </div>
  </div>
  <div v-if="params.type === 4" class="content">
    <div class="cItem" v-for="(item, index) in list" :key="index" @click="videoDetail(item)">
      <img :src="item.video_page" />
      <!-- <video :class="item.video_type === 2 ? 'videoJust' : 'videoWide'" :src="item.sources" controls="controls" controlslist="nodownload" playsinline :poster="item.video_page" /> -->
      <a :id="'title'+ index" />
      <P>{{index + 1}}.{{item.title}}</P>
    </div>
  </div>
  <div v-else class="content" >
    <div class="tItem" v-for="(item, index) in list" :key="index" @click="directionsDetail(item)">
      <img :src="item.pt_page" />
      <a :id="'title'+ index" />
      <p>{{item.title}}</p>
      <!-- <div v-html="item.content" style="margin-top: 0.4rem"></div> -->
    </div>
  </div>
 </div>
</template>

<script>
// import topMenu from '../components/topMenu'
import topMenu from '../components/topMenu'
import catalogue from '../components/catalogue'
import { getList } from '../api/wap'
export default {
  name: 'productDirection',
  components: {
    topMenu,
    catalogue
  },
  data () {
    return {
      show: false,
      list: [],
      series_data: [],
      downloadLink: '',
      seriesName: '',
      params: {
        type: 4,
        series_id: ''
      },
      type: 0
    }
  },
  created () {
    const that = this
    if (this.$route.query.series_id) {
      this.params.series_id = this.$route.query.series_id
      this.type = Number(this.$route.query.xiabiao)
      this.onLoadSeriesData(() => {
        that.onLoadData()
      })
    }
    this.onLoadSeriesData(() => {
      that.onLoadData()
    })
  },
  methods: {
    onLoadSeriesData (callBack) {
      getList({ type: 1 })
        .then(res => {
          this.downloadLink = res.result.download_url.android
          this.series_data = res.result.series_data
          // this.params.series_id = this.series_data[0].series_id
          // this.seriesName = this.series_data[0].names
          if (callBack) {
            callBack()
          }
        })
    },
    onLoadData () {
      getList(this.params)
        .then(res => {
          this.list = res.result.list
        })
    },
    onChange (type) {
      this.params.type = type
      this.list = []
      this.$router.push({
        path: '/productDirection',
        query: {
          series_id: this.params.series_id,
          type: this.params.type
        }
      })
      this.onLoadData()
    },
    onSelectSeries (item, index) {
      this.params.series_id = item.series_id
      this.seriesName = item.names
      this.type = index
      this.$router.push({
        path: '/productDirection',
        query: {
          series_id: item.series_id,
          type: this.params.type,
          xiabiao: this.type
        }
      })
      this.onLoadData()
      this.show = false
    },
    videoDetail (e) {
      this.$router.push({
        path: '/videoDetail',
        query: {
          sources: e.sources,
          title: e.title,
          video_page: e.video_page
        }
      })
    },
    directionsDetail (e) {
      localStorage.setItem('content', e.content)
      this.$router.push({
        path: '/directionsDetail',
        query: {
          // content: e.content,
          title: e.title
        }
      })
    }
  }
}
</script>

<style scoped>
.productDirection >>> .van-popup--bottom.van-popup--round {
  border-radius: 0.16rem 0.16rem 0 0;
}
.title {
  font-size: 0.36rem;
  font-weight: bold;
  color: #000;
  text-align: center;
  margin-top: 0.6rem;
}
.selectType {
  margin: 0.4rem 0.2rem 0 0.2rem;
  padding: 0.3rem 0.26rem;
  /* width: 100%; */
  box-shadow:0rem 0rem 0.46rem 0rem rgba(4,0,0,0.13);
  border-radius:0.16rem;
  font-size: 0.3rem;
  color: #121212;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.selectType img {
  width:0.48rem;
  height:0.28rem;
}
.navbar {
  margin-top: 0.6rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.navbar .navBarItem {
  text-align: center;
  position: relative;
}
.dot{
  width: 100%;
  background: #FDBA47;
  height: 0.15rem;
  position: absolute;
  border-radius: 0.5rem;
  bottom: 0.01rem;
  z-index: -1;
}
.navbar .navBarItem img {
  width:1.5rem;
  height:1.5rem;
}
.navbar .navBarItem p {
  margin-top: 0.2rem;
  font-size: 0.34rem;
  color: #121212;
}
.seriesList .tit {
  width:1.2rem;
  height:1.2rem;
  border-radius: 0.2rem;
  border:1px solid rgba(0,0,0,1);
  margin: 0 0.28rem;
  font-size:0.26rem;
  font-family:PingFang SC;
  font-weight:500;
  color:rgba(1,1,1,1);
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  text-align: center;
}
.seriesList .act{
  border: none;
  color: #fff;
}
.imgSelected {
  width:1.8rem !important;
  height:1.8rem !important;
}
.seriesList .imgActive {
  width:1.2rem !important;
  height:1.2rem !important;
  border-radius: 0.2rem;
  opacity: 1 !important;
}
.seriesTxt{
  margin-top: 0.2rem;
  font-size: 0.26rem;
  color: #919191;
}
.txtActive{
  margin-top: 0.2rem;
  font-size: 0.26rem;
  color: #121212;
}
.textSelected {
  margin-top: 0.3rem !important;
  font-size: 0.5rem !important;
  color: #121212 !important;
  font-weight: bold;
}
.tItem >>> img {
  width: 100%;
}
.content {
  padding-bottom: 0.5rem;
  margin: 0 0.1rem;
  display: flex;
  flex-wrap: wrap;
}
.tItem {
  margin-top: 0.59rem;
  width: 3.45rem;
  border:1px solid rgba(188,188,188,1);
  border-radius:0.1rem;
  margin-left: 0.1rem;
  margin-right: 0.1rem;
  padding-bottom: 0.2rem;
}
.tItem  p{
  color: #121212;
  font-size: 0.26rem;
  padding: 0.2rem 0.2rem 0;
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:1;
}
.tItem img {
  width: 100%;
  height: 1.95rem;
  background-color: #121212;
}
.listTitle {
  position: fixed;
  bottom: 37%;
  left: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  z-index: 4000;
}
.listTitle label {
  width:1.37rem;
  height:0.73rem;
  background:rgba(250,170,34,1);
  border-radius:0.16rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.seriesList {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 0.2rem;
  padding: 0.3rem 0;
  overflow-x: scroll;
}
.seriesItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.cItem {
  margin-top: 0.59rem;
  width: 3.45rem;
  border:1px solid rgba(188,188,188,1);
  border-radius:0.1rem;
  margin-left: 0.1rem;
  margin-right: 0.1rem;
  padding-bottom: 0.2rem;
}
.cItem p {
  color: #121212;
  font-size: 0.26rem;
  padding: 0.2rem 0.2rem 0;
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-box-orient:vertical;
  -webkit-line-clamp:1;
}
.cItem img {
  width: 100%;
  height: 1.95rem;
  background-color: #121212;
}
.videoJust {
  width: 7.1rem;
  height:7.1rem
}
.videoWide {
  width: 7.1rem;
  height: 4rem;
}
</style>
